<template>
	<div class="replenishment-card">
		<p class="card-head">
			<i class="fa fa-refresh" aria-hidden="true"></i>
			<span>{{ $t("chatMessageReplenishment.title") }}</span>
		</p>

		<!-- 餐厅分组列表，超出卡片可视高度时内部滚动 -->
		<div class="groups">
			<div class="group" v-for="(group, index) in groups" :key="index">
				<p class="group-name">{{ group.name }}</p>
				<p class="group-row">
					<span>{{ $t("chatMessageReplenishment.deliveryDate") }}</span>
					<span>{{ group.deliveryDate }}</span>
				</p>
				<p class="group-row">
					<span>{{ $t("chatMessageReplenishment.items") }}</span>
					<span>{{ group.itemCount }}</span>
				</p>
			</div>
		</div>

		<!-- 状态标签 -->
		<div class="status-bar">
			<span class="status-tag" :class="status">{{ statusText }}</span>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default {
	name: "chat-message-replenishment",

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data() {
		return {
			// 确认人缺省占位
			placeholder: "-",
		};
	},

	computed: {
		// 餐厅分组（当前消息为单餐厅结构，包装为分组数组以支持分组展示与分隔线）
		groups() {
			return [
				{
					name: this.message.replenishment_customer_name,
					deliveryDate: this.message.replenishment_delivery_date ? moment(this.message.replenishment_delivery_date).format("YYYY/MM/DD") : "",
					itemCount: (this.message.replenishment_items || []).length,
				},
			];
		},

		// 状态：confirmed 已确认 / expired 已过期 / confirming 待确认
		status() {
			if (this.message.replenishment_status === "confirmed") {
				return "confirmed";
			}
			if (this.message.replenishment_status === "expired") {
				return "expired";
			}
			if (this.message.replenishment_expires_at && moment(this.message.replenishment_expires_at + "+00:00").isBefore(moment())) {
				return "expired";
			}
			return "confirming";
		},

		statusText() {
			if (this.status === "confirming") {
				return this.$t("chatMessageReplenishment.confirming");
			}
			if (this.status === "expired") {
				return this.$t("chatMessageReplenishment.expired");
			}

			return this.$t("chatMessageReplenishment.confirmed", {
				name: this.message.replenishment_confirmed_by || this.message.confirmed_by || this.placeholder,
			});
		},
	},
};
</script>

<style lang="less" scoped>
.card-head {
	margin: 0 0 8px;

	> i {
		font-weight: 500;
		color: black;
		font-size: 16px;
	}

	> span {
		font-weight: 600;
		color: black;
		font-size: 16px;
		margin-left: 3px;
	}
}

.groups {
	max-height: 260px;
	overflow-y: auto;

	.group {
		& + .group {
			margin-top: 8px;
			padding-top: 8px;
			border-top: 1px solid #c9c9c9;
		}

		.group-name {
			margin: 0 0 4px;
			font-weight: 600;
			color: black;
			font-size: 14px;
			word-break: break-all;
		}

		.group-row {
			display: flex;
			justify-content: space-between;
			margin: 0;

			> span {
				color: #404040;
				font-weight: 500;
			}
		}
	}
}

.status-bar {
	margin-top: 8px;
	padding-top: 8px;
	border-top: 1px solid #c9c9c9;

	.status-tag {
		display: inline-block;
		padding: 2px 10px;
		border-radius: 10px;
		font-size: 12px;
		font-weight: 500;

		&.confirming {
			color: #e6a23c;
			background-color: #fdf6ec;
		}

		&.expired {
			color: #909399;
			background-color: #f4f4f5;
		}

		&.confirmed {
			color: #67c23a;
			background-color: #f0f9eb;
		}
	}
}
</style>
